import { queryOptions } from '@tanstack/vue-query'
import type { MaybeRef } from 'vue'
import type { ID } from '#shared/index'
import type { Message } from '../model/message'

// Fresh messages - messages sent by current user or coming from WebSocket

export const getFreshMessagesQueryKeyGlobalPrefix = () => ['_virtial', 'fresh-messages'] as const

export const getFreshMessagesQueryKey = (chatId: MaybeRef<ID>) => ['_virtial', 'fresh-messages', chatId] as const

export const getFreshMessagesQueryOptions = (chatId: MaybeRef<ID>) =>
  queryOptions({
    queryKey: getFreshMessagesQueryKey(chatId),
    queryFn: () => Promise.resolve([] as Message[]),
    staleTime: Infinity,
    gcTime: Infinity,
  })
